import * as React from 'react';

interface IFileTypeIconProps {
  className?: string;
}

// 書類の形に種類の文字を添えたアイコン。DXF と PDF で共用する
function renderDocumentIcon(label: string, className: string | undefined): React.ReactElement {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6 2h8l4 4v16H6z" />
      <path d="M14 2v5h4" />
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fontSize="6"
        fontWeight="bold"
        stroke="none"
        fill="currentColor"
      >
        {label}
      </text>
    </svg>
  );
}

export const DxfFileIcon: React.FC<IFileTypeIconProps> = function (props) {
  return renderDocumentIcon('DXF', props.className);
};

export const PdfFileIcon: React.FC<IFileTypeIconProps> = function (props) {
  return renderDocumentIcon('PDF', props.className);
};

export const ImageFileIcon: React.FC<IFileTypeIconProps> = function (props) {
  return (
    <svg
      className={props.className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="8.5" cy="9.5" r="1.5" />
      <path d="M21 16l-5-5-6 6-2.5-2.5L3 19" />
    </svg>
  );
};
